var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "87px",
    height: "84px",
    viewBox: "0 0 87 84",
    enableBackground: "new 0 0 87 84",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#575E61",
    points: "42.228,27.994 35.021,27.994 32.535,41.993 39.742,41.993 40.841,35.768 43.255,41.993  50.828,41.993 53.312,27.998 45.741,27.998 44.622,34.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#575E61",
    points: "8.393,38.552 10.259,27.998 2.472,27.998 0,42.001 12.159,42.001 12.769,38.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#575E61",
    points: "22.555,28.004 14.643,28.004 12.9,37.796 20.812,37.796  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F5556",
    d: "M44.505,34.437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575E61",
    d: "M23.088,37.492c-0.139,0.801-0.451,1.06-1.049,1.06l-1.362-0.005l-0.609,3.454h5.547 c2.988,0,4.671-1.579,5.305-5.163l1.567-8.834l-7.721,0.001L23.088,37.492z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDD00",
    points: "86.8,0 29.726,0 26.214,19.826 83.283,19.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDD00",
    points: "14.855,84 71.926,84 78.953,44.33 21.874,44.33  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#575E61",
    points: "22.056,24.209 22.693,24.209 22.814,23.522 22.175,23.522 22.272,23.044 23.417,23.044  23.564,22.166 20.707,22.166 20.086,25.657 22.949,25.657 23.112,24.738 21.969,24.737  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575E61",
    d: "M17.196,24.721h-0.248l0.288-1.662h0.248c0,0,0.273-0.017,0.471,0.042c0.172,0.049,0.385,0.327,0.305,0.775 c-0.1,0.566-0.389,0.767-0.661,0.823C17.468,24.73,17.196,24.721,17.196,24.721z M18.669,25.609 c0.578-0.124,1.171-0.521,1.387-1.729c0.172-0.951-0.265-1.454-0.618-1.597c-0.283-0.114-0.752-0.117-1.015-0.117l-2.753-0.001 l-0.614,3.492c0,0,2.547,0,2.759,0C18.026,25.657,18.384,25.667,18.669,25.609z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "53.716,25.663 54.336,22.167 43.695,22.167 43.077,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "42.6,25.663 43.217,22.167 25.797,22.167 25.18,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "60.527,25.663 61.148,22.167 54.837,22.167 54.217,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "64.812,25.663 65.434,22.167 61.715,22.167 61.094,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "67.762,25.663 68.378,22.167 66.09,22.167 65.477,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "69.925,25.663 70.546,22.167 69.126,22.167 68.512,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "71.609,25.663 72.23,22.167 71.418,22.167 70.8,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "73.286,25.663 73.908,22.167 73.279,22.167 72.659,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "74.752,25.663 75.374,22.167 74.98,22.167 74.367,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "76.391,25.663 77.01,22.167 76.706,22.167 76.087,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "78.115,25.663 78.736,22.167 78.458,22.167 77.841,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "80.021,25.663 80.641,22.167 80.426,22.167 79.807,25.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000099",
    points: "82.255,25.663 82.87,22.167 82.702,22.167 82.088,25.663  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8723c09c68b88ea56861fc0c88f644c2.svg";
export { ForwardRef as ReactComponent };